import {
  Directive,
  DoCheck,
  ElementRef,
  HostListener
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appIndianNumberFormat]'
})
export class IndianNumberFormatDirective implements DoCheck {

  private lastValue = '';

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {}

  ngDoCheck(): void {
    const value = this.control?.control?.value;

    if (value == null || value === '') {
      this.lastValue = '';
      this.el.nativeElement.value = '';
      return;
    }

    const raw = String(value).replace(/,/g, '');

    if (raw !== this.lastValue) {
      this.lastValue = raw;
      this.el.nativeElement.value = this.format(raw);
    }
  }

  @HostListener('focus')
  onFocus(): void {
    this.el.nativeElement.value = this.lastValue;
  }

  @HostListener('blur')
  onBlur(): void {
    this.el.nativeElement.value = this.format(this.lastValue);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    const prevValue = input.value;
    const cursorPos = input.selectionStart ?? prevValue.length;

    // How many digits sit before the cursor in the value as typed
    const digitsBeforeCursor = prevValue
      .slice(0, cursorPos)
      .replace(/[^\d]/g, '').length;

    const raw = input.value.replace(/[^\d]/g, '');

    this.lastValue = raw;

    this.control.control?.setValue(raw, { emitEvent: false });

    const formatted = this.format(raw);
    input.value = formatted;

    const newPos = this.getCursorPosFromDigitCount(formatted, digitsBeforeCursor);
    input.setSelectionRange(newPos, newPos);
  }

  private format(value: string): string {
    if (!value) {
      return '';
    }
    return Number(value).toLocaleString('en-IN');
  }

  // Walk the formatted string and find the index right after
  // the Nth digit (commas don't count).
  private getCursorPosFromDigitCount(formatted: string, digitCount: number): number {
    if (digitCount <= 0) {
      return 0;
    }

    let seen = 0;
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) {
        seen++;
        if (seen === digitCount) {
          return i + 1;
        }
      }
    }
    return formatted.length;
  }
}